import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';

@Component({
  selector: 'app-document-form-notif-aff',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-notif-aff.component.html',
  styleUrl: './document-form-notif-aff.component.scss',
})
export class DocumentFormNotifAffComponent extends DocumentFormBase<NotifAffForm> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createNotifAffForm(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      this.form.get('dateFinValidite')?.setValue(undefined);
    }
  }
}

export function createNotifAffForm(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type NotifAffForm = ReturnType<typeof createNotifAffForm>;
export type NotifAffFormValue = NotifAffForm['value'];
